
namespace TabAurous.OMS {

    @Serenity.Decorators.registerClass()
    export class RewardsDetailsGrid extends Serenity.EntityGrid<RewardsDetailsRow, any> {
        protected getColumnsKey() { return 'OMS.RewardsDetails'; }
        protected getDialogType() { return RewardsDetailsDialog; }
        protected getIdProperty() { return RewardsDetailsRow.idProperty; }
        protected getInsertPermission() { return RewardsDetailsRow.insertPermission; }
        protected getLocalTextPrefix() { return RewardsDetailsRow.localTextPrefix; }
        protected getService() { return RewardsDetailsService.baseUrl; }

        constructor(container: JQuery) {
            super(container);
            this.slickGrid.setOptions({ rowHeight: 30 });
        }
    }
}